import React from "react";
import GroupImage from "../../assets/Images/marketing/group-image.png";
import * as Yup from "yup";
import { Formik } from "formik";
import RevealAnimation from "../RevealAnimation";

function AwsSaving({ handelSubmit, title, listItem = [] }) {
  const validateSchema = Yup.object().shape({
    firstName: Yup.string().required("This field is required"),
    lastName: Yup.string().required("This field is required"),
    email: Yup.string()
      .email("Please enter a valid email")
      .required("This field is required"),
    phone: Yup.string()
      .required("This field is required")
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        "Phone number is not valid"
      ),
    message: Yup.string().required("This field is required"),
    referral_source: Yup.string().required("This field is required"),
    referral_source_other: Yup.string().when("referral_source", {
      is: "Other",
      then: (schema) => schema.required("This field is required"),
      otherwise: (schema) => schema.nullable(),
    }),
  });

  return (
    <div className="mt-50 body-container">
      <div className="aws-saving">
        <div className="stats-section">
          {title && (
            <RevealAnimation animation="slide-left">
              <h3>{title}</h3>
            </RevealAnimation>
          )}

          <ul className="stats-list">
            {listItem?.map((item, keyName) => (
              <li key={keyName}>
                <span>
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      y="0.26825"
                      width="24"
                      height="24"
                      rx="12"
                      fill="#E89F38"
                    />
                    <path
                      d="M18 5.86823L17.8364 5.75312L17.8363 5.75327L17.8359 5.75391L17.834 5.75655L17.8265 5.76719L17.7965 5.80952C17.77 5.84695 17.7303 5.9026 17.6783 5.97528C17.5743 6.12065 17.4205 6.33415 17.2221 6.60627C16.8253 7.15052 16.2497 7.92922 15.5354 8.86637C14.1064 10.7409 12.1229 13.2483 9.90367 15.7811C9.37776 16.381 8.90051 16.6 8.49311 16.6261C8.08233 16.6524 7.70105 16.4853 7.36422 16.2294C7.02742 15.9736 6.75049 15.6402 6.55592 15.3658C6.45924 15.2295 6.38428 15.1097 6.33373 15.0244C6.30847 14.9818 6.28938 14.948 6.27678 14.9251L6.26281 14.8994L6.25956 14.8932L6.25889 14.8919L6.25886 14.8919C6.25884 14.8918 6.25882 14.8918 6.25881 14.8918L6.2588 14.8918C6.2192 14.8152 6.13499 14.7726 6.04984 14.7861C5.96465 14.7996 5.89771 14.8662 5.88377 14.9513C5.69619 16.0971 5.8337 16.9783 6.19672 17.6173C6.56149 18.2594 7.14102 18.634 7.78759 18.7867C9.06416 19.0883 10.625 18.5323 11.4303 17.46L11.4304 17.46C12.5341 15.9903 14.2229 13.1104 15.6303 10.6091C16.3354 9.3562 16.9719 8.19455 17.4321 7.34617C17.6622 6.92195 17.8483 6.576 17.9769 6.33607C18.0412 6.2161 18.0911 6.12263 18.125 6.05912L18.1635 5.98677L18.1733 5.96827L18.1758 5.96357L18.1764 5.96238L18.1766 5.96208C18.1766 5.96201 18.1767 5.96197 18 5.86823ZM18 5.86823L17.8365 5.75308C17.8973 5.66675 18.0147 5.64254 18.1047 5.69779C18.1946 5.75304 18.2262 5.86871 18.1767 5.96197L18 5.86823Z"
                      fill="white"
                      stroke="white"
                      strokeWidth="0.4"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <img src={GroupImage} alt="" />
        </div>

        <div className="contact-section" id="contact-aws-saving">
          <RevealAnimation animation="slide-left">
            <h2>
              Contact <span className="text-gray-dark">Us</span>
            </h2>
          </RevealAnimation>

          <Formik
            initialValues={{
              firstName: "",
              lastName: "",
              email: "",
              phone: "",
              organization: "",
              challenges: [],
              jobTitle: "",
              preferred_audit_type: "",
              referral_source: "",
              referral_source_other: "",
            }}
            validationSchema={validateSchema}
            onSubmit={(values) => {
              handelSubmit(values);
            }}
          >
            {({
              values,
              errors,
              handleChange,
              touched,
              handleSubmit,
              handleBlur,
            }) => {
              return (
                <div class="contact-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="firstName" className="label-only">
                        <span className="text-red">*</span>First Name
                      </label>
                      <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        value={values.firstName}
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.firstName && errors.firstName && (
                        <div className="form-error">{errors.firstName}</div>
                      )}
                    </div>

                    <div className="form-group">
                      <label htmlFor="lastName" className="label-only">
                        <span className="text-red">*</span>Last Name
                      </label>
                      <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        value={values.lastName}
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.lastName && errors.lastName && (
                        <div className="form-error">{errors.lastName}</div>
                      )}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="email" className="label-only">
                        <span className="text-red">*</span>Business Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={values.email}
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.email && errors.email && (
                        <div className="form-error">{errors.email}</div>
                      )}
                    </div>

                    <div className="form-group">
                      <label htmlFor="phone" className="label-only">
                        <span className="text-red">*</span>Phone Number
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={values.phone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        id="phone"
                        required
                      />
                      {touched.phone && errors.phone && (
                        <div className="form-error">{errors.phone}</div>
                      )}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="jobTitle" className="label-only">
                        <span className="text-red">*</span>Job Title
                      </label>
                      <input
                        type="text"
                        name="jobTitle"
                        value={values.jobTitle}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        id="jobTitle"
                        required
                      />{" "}
                      {touched.jobTitle && errors.jobTitle && (
                        <div className="form-error">{errors.jobTitle}</div>
                      )}
                    </div>

                    <div className="form-group">
                      <label htmlFor="organization" className="label-only">
                        <span className="text-red">*</span>Company Name
                      </label>
                      <input
                        type="text"
                        name="organization"
                        onChange={handleChange}
                        value={values.organization}
                        onBlur={handleBlur}
                        id="organization"
                        required
                      />
                      {touched.organization && errors.organization && (
                        <div className="form-error">{errors.organization}</div>
                      )}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="referral_source" className="label-only">
                        <span className="text-red">*</span>How did you hear
                        about us?
                      </label>
                      <select
                        name="referral_source"
                        onChange={handleChange}
                        value={values.referral_source}
                        onBlur={handleBlur}
                        id="referral_source"
                        required
                      >
                        <option></option>
                        <option>Google Search</option>
                        <option>Facebook Ads</option>
                        <option>LinkedIn</option>
                        <option>Instagram</option>
                        <option>Clutch</option>
                        <option>Referral</option>
                        <option>Other</option>
                      </select>

                      {touched.referral_source && errors.referral_source && (
                        <div className="form-error">
                          {errors.referral_source}
                        </div>
                      )}
                    </div>
                    {values.referral_source === "Other" && (
                      <div className="form-group">
                        <label htmlFor="referral_source" className="label-only">
                          <span className="text-red">*</span>Please specify
                        </label>

                        <input
                          type="text"
                          name="referral_source_other"
                          onChange={handleChange}
                          value={values.referral_source_other}
                          onBlur={handleBlur}
                          required
                        />

                        {touched.referral_source_other &&
                          errors.referral_source_other && (
                            <div className="form-error">
                              {errors.referral_source_other}
                            </div>
                          )}
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="message" className="label-only">
                      Message
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={values.message}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      rows="3"
                    ></textarea>
                    {touched.message && errors.message && (
                      <div className="form-error">{errors.message}</div>
                    )}
                  </div>

                  <div class="form-footer">
                    <button
                      type="submit"
                      onClick={handleSubmit}
                      class="submit-btn"
                    >
                      Submit →
                    </button>
                  </div>

                  <div class="checkboxes">
                    {["100% confidential", "We sign NDAs"]?.map((item, val) => (
                      <label key={val} class="checkbox-label">
                        <span>
                          <svg
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.26825"
                              width="24"
                              height="24"
                              rx="12"
                              fill="#E89F38"
                            />
                            <path
                              d="M18 5.86823L17.8364 5.75312L17.8363 5.75327L17.8359 5.75391L17.834 5.75655L17.8265 5.76719L17.7965 5.80952C17.77 5.84695 17.7303 5.9026 17.6783 5.97528C17.5743 6.12065 17.4205 6.33415 17.2221 6.60627C16.8253 7.15052 16.2497 7.92922 15.5354 8.86637C14.1064 10.7409 12.1229 13.2483 9.90367 15.7811C9.37776 16.381 8.90051 16.6 8.49311 16.6261C8.08233 16.6524 7.70105 16.4853 7.36422 16.2294C7.02742 15.9736 6.75049 15.6402 6.55592 15.3658C6.45924 15.2295 6.38428 15.1097 6.33373 15.0244C6.30847 14.9818 6.28938 14.948 6.27678 14.9251L6.26281 14.8994L6.25956 14.8932L6.25889 14.8919L6.25886 14.8919C6.25884 14.8918 6.25882 14.8918 6.25881 14.8918L6.2588 14.8918C6.2192 14.8152 6.13499 14.7726 6.04984 14.7861C5.96465 14.7996 5.89771 14.8662 5.88377 14.9513C5.69619 16.0971 5.8337 16.9783 6.19672 17.6173C6.56149 18.2594 7.14102 18.634 7.78759 18.7867C9.06416 19.0883 10.625 18.5323 11.4303 17.46L11.4304 17.46C12.5341 15.9903 14.2229 13.1104 15.6303 10.6091C16.3354 9.3562 16.9719 8.19455 17.4321 7.34617C17.6622 6.92195 17.8483 6.576 17.9769 6.33607C18.0412 6.2161 18.0911 6.12263 18.125 6.05912L18.1635 5.98677L18.1733 5.96827L18.1758 5.96357L18.1764 5.96238L18.1766 5.96208C18.1766 5.96201 18.1767 5.96197 18 5.86823ZM18 5.86823L17.8365 5.75308C17.8973 5.66675 18.0147 5.64254 18.1047 5.69779C18.1946 5.75304 18.2262 5.86871 18.1767 5.96197L18 5.86823Z"
                              fill="white"
                              stroke="white"
                              strokeWidth="0.4"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <span>{item}</span>
                      </label>
                    ))}
                  </div>
                </div>
              );
            }}
          </Formik>
          <RevealAnimation animation="slide-left">
            <p className="privacy-notice">
              To give you the content requested, we need to store and process
              your personal data. For information on how to unsubscribe, as well
              as our privacy practices and commitment to protecting your
              privacy, please review our <a href="#">Privacy Policy</a>.
            </p>
          </RevealAnimation>
        </div>
      </div>
    </div>
  );
}

export default AwsSaving;
